import {
  CssBaseline,
  StylesProvider as MuiStylesProvider,
  ThemeProvider,
} from '@material-ui/core';
import { linkpickfr } from '@webapps/lang';
import {
  AuthProvider,
  NotifProvider,
  PaymentProvider,
  PickersUtilsProvider,
  QueryProvider,
  StropheProvider,
  ToastProvider,
  ToastProviderNoAutoDelete,
} from '@webapps/reactjs-tech-components';
import { StylesProvider, linkpickTheme } from '@webapps/styles';
import RouteChangeTracker from 'assets/RouteChangeTracker';
import ScrollToTopFunction from 'assets/ScrollToTopFunction';
import App from 'components/App';
import { CvProvider } from 'pages/MyMap/Store/CvProvider';
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <QueryProvider>
        <AuthProvider>
          <MuiStylesProvider injectFirst>
            <ThemeProvider theme={linkpickTheme.mui}>
              <PickersUtilsProvider>
                <StylesProvider>
                  <CssBaseline />
                  <IntlProvider
                    defaultLocale="fr"
                    locale={navigator.language}
                    messages={linkpickfr}
                  >
                    <ToastProviderNoAutoDelete>
                      <ToastProvider>
                        <NotifProvider>
                          <StropheProvider>
                            
                            <ScrollToTopFunction />
                            <RouteChangeTracker />
                            <DndProvider backend={HTML5Backend}>
                              <CvProvider> 
                                <PaymentProvider>
                                  <App />
                                </PaymentProvider>
                              </CvProvider>
                            </DndProvider> 
                          </StropheProvider>
                        </NotifProvider>
                      </ToastProvider>
                    </ToastProviderNoAutoDelete>
                  </IntlProvider>
                </StylesProvider>
              </PickersUtilsProvider>
            </ThemeProvider>
          </MuiStylesProvider>
        </AuthProvider>
      </QueryProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);